import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { VariantProps } from ".";
import PlusShippingLevels from "../PlusShippingLevels";
import GoogleViewPrice from "../GoogleViewPrice";
import ChatLink from "./ChatLink";
import EmailInstantlyForPrice from "./EmailInstantlyForPrice";
import GetPriceByEmail from "./GetPriceByEmail";
import WhyWeDoThis from "./WhyWeDoThis";

const K = (props: VariantProps) => {
  const {
    price,
    hasWebPlusDiscountedShipping,
    allowWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    itemNumber,
    unitOfMeasure,
    isGoogleView,
    minimumBuy,
    mustBuy,
    user,
  } = props;

  return (
    <div className="map map-override mapK">
      <label>Each Only</label>
      {isGoogleView ? (
        <GoogleViewPrice
          price={price.price}
          minimumBuy={minimumBuy}
          mustBuy={mustBuy}
          priceCrossedOut
        />
      ) : (
        <>
          <p className="price">
            <span className="line-through">
              {formatAsCurrency.formatIfUndefined(price.price)}
            </span>
            <span className="each line-through decoration-red-500">{`/${unitOfMeasure}`}</span>
          </p>
        </>
      )}
      <PlusShippingLevels
        hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping}
        allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping}
        isWebstaurantPlusEligible={isWebstaurantPlusEligible}
        user={user}
      />
      <EmailInstantlyForPrice
        loginOverride={showBelowMinimumAdvertisedPriceForLoggedInCustomers}
      />
      <GetPriceByEmail itemNumber={itemNumber} />
      {!price.hideWhyDoWeDoThis && <WhyWeDoThis type="contact" />}
      <p className="mapText map3">
        <ChatLink />
        {" with a Customer Service rep to receive the price!"}
        <br />
        Mon-Thu 8AM-8PM EST · Fri 8AM-6PM EST · Sat 9AM-4PM EST
      </p>
    </div>
  );
};

export default K;
